if (!window.customElements.get('bundled-products')) {
  window.customElements.define('bundled-products',
    class BundledProducts extends HTMLElement {
      constructor() {
        super();
        this.bundleTitle = this.dataset.bundleTitle;
        this.formContainer = this.querySelector('.bundled-products__form');
        this.addToCartBtn = this.formContainer.querySelector('[data-bundle-add-to-cart]');
        this.btnTextEl = this.addToCartBtn?.querySelector('[data-bundle-add-to-cart-text]');
      
        this.baseInput = this.formContainer?.querySelector('[data-base-variant]');
        this.bundleInput = this.formContainer?.querySelector('[data-bundle-variant]');
        this.setActiveTabHeight();
        this.initTabSelector();
      }

      connectedCallback() {
        this.init();
      }
      
      init() {
        this.querySelectorAll('.bundled-product__variant-options').forEach((optionSet) => {
          optionSet.addEventListener('change', (event) => {
            if (event.target.matches('[data-variant-input]')) {
              this.selectVariant(optionSet);
            }
          });
        });
      
        if (this.addToCartBtn) {
          this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
        }
      }

      setActiveTabHeight() {
        const activeTab = this.querySelector('.bundled-product__tab.active');
        const tabsContainer = this.querySelector('.bundled-products__tabs');
      
        if (activeTab && tabsContainer) {
          const tabHeight = activeTab.offsetHeight;
          tabsContainer.style.height = `${tabHeight}px`;
        }
      }
      
      handleAddToCart(event) {
        event.preventDefault();
      
        const baseId = this.baseInput?.value;
        const bundleId = this.bundleInput?.value;
      
        if (!baseId || !bundleId) return;

        let bundleRanId = Date.now();

        let formData = {
          'items': [
            {
              'quantity': 1,
              'id': bundleId,
              'properties': {
                '_bundleProduct': bundleRanId,
                '_bundleTitle': this.bundleTitle
              }
            },
            {
              'quantity': 1,
              'id': baseId,
              'properties': {
                '_bundleProduct': bundleRanId,
                '_bundleTitle': this.bundleTitle
              }
            }
          ]
        };
        
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((data) => {
          this.formContainer.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              addToCartBtn: this.addToCartBtn
            },
            bubbles: true
          }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      initTabSelector() {
        const selectors = this.querySelectorAll('.bundled-products__selector--option');
        const tabs = this.querySelectorAll('.bundled-product__tab');
    
        selectors.forEach((selector) => {
          selector.addEventListener('click', () => {
            const index = selector.dataset.index;
    
            selectors.forEach(s => s.classList.remove('active'));
            selector.classList.add('active');

            tabs.forEach((tab) => {
              if (tab.dataset.tabIndex === index) {
                tab.classList.add('active');
                const optionSet = tab.querySelector('.bundled-product__variant-options');
                if (optionSet) this.selectVariant(optionSet);
              } else {
                tab.classList.remove('active');
              }
            });

            this.setActiveTabHeight();
            this.updateSelectorToggle(index);
          });
        });
      }

      updateSelectorToggle(index) {
        const selector = this.querySelector('.bundled-products__selector');
        const options = selector.querySelectorAll('.bundled-products__selector--option');
        const total = options.length;
      
        // Guard against divide by zero
        if (total <= 1) return;
      
        const translatePercent = (index - 1) * (100 / (total - 1));
      
        selector.style.setProperty('--toggle-x', `${translatePercent}%`);
        selector.style.setProperty('--toggle-count', total);
      }

      selectVariant(optionSet) {
        const select = optionSet.querySelector('select[data-product-select]');

        if (!select) return;
      
        const checkedInputs = optionSet.querySelectorAll('input[type="radio"]:checked');
      
        const selectedValues = Array.from(checkedInputs).map((input) => input.value.trim());
      
        const expectedTitle = selectedValues.join(' / ');
      
        const matchingOption = Array.from(select.options).find((option) => {
          const title = option.dataset.title?.trim() || '';
          return title === expectedTitle;
        });

        if (matchingOption) {
          let variantAvailable = matchingOption.disabled ? false : true;

          console.log(variantAvailable, matchingOption.value)

          if(variantAvailable) {
            select.value = matchingOption.value;
          }

          this.updateForm(optionSet, matchingOption, variantAvailable);
          this.updateBundleProductImage(optionSet, matchingOption);

        } else {
          this.updateForm(optionSet, null, false)
        }
      }

      updateBundleProductImage(optionSet, matchingOption) {
        const variantId = matchingOption.value;
        const parent = optionSet.closest('.bundled-product__tab');
        if (parent) {
          const variantImages = parent.querySelectorAll('.bundled-product__image--wrapper');
          if(variantImages.length > 0) {
            variantImages.forEach((image) => {
              image.classList.remove('active');
              if (image.dataset.variantId == variantId) {
                image.classList.add('active');
              }
            });
          }
        }
      }

      updateForm(optionSet, matchingOption, variantAvailable) {
        if (this.formContainer) {
            const inputSelector = optionSet.hasAttribute('data-bundle-product')
              ? '[data-bundle-variant]'
              : '[data-base-variant]';
      
            const variantInput = this.formContainer.querySelector(inputSelector);
            if (variantInput) {
              variantInput.value = variantAvailable ? matchingOption.value : '';
            }
          }
    
        if (this.addToCartBtn) {
          this.checkAddToCartState();
        }
      }

      checkAddToCartState() {
        const baseValid = this.baseInput && this.baseInput.value !== '';
        const bundleValid = this.bundleInput && this.bundleInput.value !== '';
      
        if (baseValid && bundleValid) {
          this.addToCartBtn.removeAttribute('disabled');
          if (this.btnTextEl?.dataset.defaultText) {
            this.btnTextEl.innerText = this.btnTextEl.dataset.defaultText;
          }
        } else {
          this.addToCartBtn.setAttribute('disabled', 'disabled');
          if (this.btnTextEl) {
            this.btnTextEl.innerText = theme.strings?.soldOut || 'Sold out';
          }
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const bundledProducts = document.querySelector('bundled-products');
  if (bundledProducts) {
    bundledProducts.initTabSelector();
    bundledProducts.setActiveTabHeight();
  }
});
